import React, { useContext, useState } from "react";
import {
  faExclamationTriangle,
  faTimesCircle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import { Field, Form, Formik, FormikProps } from "formik";
import {
  ManageCompanyLayout,
  SearchableList,
  DayDropdown,
  DatePicker,
  FieldInput,
  FieldDropSide,
  FieldButtonGroup,
  LoaderWrapper,
  CompanyLogoUpload,
  ImageUpload,
} from "../../components";
import {
  manageTransactionStore,
  setManageTransactionToastInfo,
} from "../../contexts";
import {
  getAdvancedPathWithParam,
  getPathWithParam,
  MANAGE_TRANSACTION_ROUTES,
} from "../../utils";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
const RejectRequestModal = ({
  show,
  setShow,
  totalRequestAmount,
  setVal,
  history,
  amount,
  ApproveOrRejectRollOverIn,
  RejectApiForRollOver,
  RejectApi,
  ApproveRejectApi,
  RejectLoan,
  empName,
  loanType,
}) => {
  const { state, dispatch } = useContext(manageTransactionStore);

  const location = useLocation();
  const handleClose = () => {
    setShow(false);
  };

  const onRejectClick = (values) => {
    //setVal(values);
    if (location.pathname.includes("manage-pending-rolloverin-approval")) {
      ApproveOrRejectRollOverIn(
        false,
        values.reasonForRejection,
        () => {
          dispatch(
            setManageTransactionToastInfo({
              showToast: true,
              toastMessage: "Rollover request is rejected",
              toastMessage2: empName,
              toastMessage1: "Rolloverin amount" + " " + amount,
              reject: true,
            })
          );
          history.push(
            getPathWithParam({
              path: `${MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL}`,
            })
          );
        },
        setShow(false)
      );
    } else if (
      location.pathname.includes("manage-pending-withdrawal-approval")
    ) {
      RejectApi(
        false,
        values.reasonForRejection,
        () => {
          dispatch(
            setManageTransactionToastInfo({
              showToast: true,
              toastMessage: "withdrawal request is rejected",
              toastMessage2: empName,
              toastMessage1: "withdrawal amount" + " " + totalRequestAmount,
              reject: true,
            })
          );
          history.push(
            getPathWithParam({
              path: `${MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL}`,
            })
          );
        },
        setShow(false)
      );
    } else if (location.pathname.includes("manage-pending-loan-approval")) {
      RejectLoan(
        false,
        values.reasonForRejection,
        values.comments,
        () => {
          dispatch(
            setManageTransactionToastInfo({
              showToast: true,
              toastMessage: "Loan request is rejected",
              toastMessage2: empName,
              toastMessage1: `Type : ${loanType}, Loan amount : ${amount}`,
              reject: true,
            })
          );
          history.push(
            getPathWithParam({
              path: `${MANAGE_TRANSACTION_ROUTES.PENDINGLOAN}`,
            })
          );
        },
        setShow(false)
      );
    }
  };
  const fields = {
    comments: "comments",
    reasonForRejection: "reasonForRejection",
  };

  const schema = Yup.object().shape({
    reasonForRejection: Yup.string().required("Required"),
    // comments: Yup.string()
    // .required("Required")
  });
  return (
    <Modal show={show} onHide={handleClose} size="md">
      <Modal.Body>
        <div
          className="d-flex"
          style={{ height: "422px", width: "500px", Radius: "10px" }}
        >
          <div className="pd-15">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              color="red"
              size="3x"
              className="mt-3"
            />
          </div>
          <div className="remove-text">
            <h4>Do you want to reject the request?</h4>

            <Formik
              onSubmit={onRejectClick}
              initialValues={{}}
              validationSchema={schema}
              validateOnBlur={false}
              validateOnChange={false}
            >
              {({ handleChange, setFieldValue, values, ...rest }) => {
                return (
                  <Form>
                    <Field
                      isRequired
                      size="md"
                      label="Reason For Rejection"
                      // placeholder="Comments"
                      name={fields.reasonForRejection}
                      onChange={handleChange}
                      type="text"
                      component={FieldInput}
                      maxLength={30}
                    />

                    <Field
                      size="md"
                      style={{
                        width: "300px",
                        marginBottom: "20px",
                        height: "100px",
                        Radius: "5px",
                      }}
                      label="Type your comments below"
                      name={fields.comments}
                      type="text"
                      onChange={handleChange}
                      // disabled={isEdit && !isSave}
                      component={FieldInput}
                      maxLength={30}
                    />
                    <br></br>

                    <Button
                      variant="secondary"
                      onClick={handleClose}
                      className="ml-5 mr-3"
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      style={{
                        backgroundColor: "red",
                        color: "#fff",
                        border: "2px solid red",
                      }}
                      type="submit"
                      // onClick={() => onRejectClick(values)}
                    >
                      Reject
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RejectRequestModal;
